import { render, staticRenderFns } from "./sectionHeader.vue?vue&type=template&id=2b824004&scoped=true&"
import script from "./sectionHeader.vue?vue&type=script&lang=js&"
export * from "./sectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./sectionHeader.vue?vue&type=style&index=0&id=2b824004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b824004",
  null
  
)

export default component.exports